import { render, staticRenderFns } from "./process_config.vue?vue&type=template&id=244e5e04&scoped=true"
import script from "./process_config.vue?vue&type=script&lang=js"
export * from "./process_config.vue?vue&type=script&lang=js"
import style0 from "./process_config.vue?vue&type=style&index=0&id=244e5e04&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e5e04",
  null
  
)

export default component.exports